import { memo, useId } from 'react';

import { Input } from '@air/primitive-input';

import { useBoundedNumberField } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useBoundedNumberField';

export type WorkspaceAgentGuidedVariantWatermarkNumberFieldProps = {
  disabled?: boolean;
  label: string;
  max: number;
  min: number;
  onChange: (value: number) => void;
  suffix: string;
  testId: string;
  value: number;
};

export const WorkspaceAgentGuidedVariantWatermarkNumberField = memo(
  ({
    disabled = false,
    label,
    max,
    min,
    onChange,
    suffix,
    testId,
    value,
  }: WorkspaceAgentGuidedVariantWatermarkNumberFieldProps) => {
    const inputId = useId();
    const {
      inputMax,
      onBlur,
      onChange: handleChange,
      value: inputValue,
    } = useBoundedNumberField({
      max,
      min,
      onChange,
      value,
    });

    return (
      <label className="flex min-w-0 flex-1 flex-col gap-1 ads:text-primary text-12 text-gray-12" htmlFor={inputId}>
        {label}
        <span className="relative">
          <Input
            className="h-8 w-full pr-7 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
            data-testid={testId}
            disabled={disabled}
            id={inputId}
            inputMode="numeric"
            max={inputMax}
            min={min}
            onBlur={onBlur}
            onChange={handleChange}
            size="medium"
            type="number"
            value={inputValue}
          />
          <span className="pointer-events-none absolute top-1/2 right-2 -translate-y-1/2 ads:text-metadata text-12 text-gray-10">
            {suffix}
          </span>
        </span>
      </label>
    );
  },
);

WorkspaceAgentGuidedVariantWatermarkNumberField.displayName = 'WorkspaceAgentGuidedVariantWatermarkNumberField';
